import { render, staticRenderFns } from "./schoolHolidaysPanel.vue?vue&type=template&id=48941614&scoped=true"
import script from "./schoolHolidaysPanel.vue?vue&type=script&lang=js"
export * from "./schoolHolidaysPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48941614",
  null
  
)

export default component.exports